import { Fragment, useEffect, useState } from 'react';
import { Typography } from '../../../molecules/Typography';
import { splitSnippetByMatches } from '../../../../utils/searchHighlight';
//import InnerHTMLContainer from "../../../molecules/InnerHTMLContainer";

interface IExerciseContent {
  text: string;
  /** Termo pesquisado, destacado no enunciado. */
  highlight?: string | null;
}

export function ExerciseContent({ text, highlight }: IExerciseContent) {
  const [stripedText, setStripedText] = useState<string>('');

  useEffect(() => {
    if (text) {
      const striped = stripHtmlTagsAdvanced(text);

      setStripedText(striped);
    }
  }, [text]);

  const stripHtmlTagsAdvanced = (html: string): string => {
    try {
      const elementoTemporario = document.createElement('div');
      elementoTemporario.innerHTML = html;

      return (
        elementoTemporario.textContent || elementoTemporario.innerText || ''
      );
    } catch (e: any) {
      return '';
    }
  };

  return (
    <div className='pr-4'>
      <Typography
        size='small'
        className='line-clamp-2 transition delay-100 ease-in-out group-hover:text-card-color-default'
      >
        {highlight
          ? splitSnippetByMatches(stripedText, highlight).map((part, index) =>
              part.match ? (
                <mark
                  key={index}
                  className='rounded-sm bg-[#ffe9a8] px-[1px] text-inherit'
                >
                  {part.text}
                </mark>
              ) : (
                <Fragment key={index}>{part.text}</Fragment>
              )
            )
          : stripedText}
      </Typography>
    </div>
  );
}
